// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"ea81d590","730":"003ade16"}[chunkId] + ".chunk.js";
};